import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { Check, Clock, Crown, Star, Sparkles } from 'lucide-react';
type OfferId = 'base' | 'combo';
interface Offer {
  id: OfferId;
  label: string;
  oldPrice: string;
  price: string;
  url: string;
}
const OFFERS: Record<OfferId, Offer> = {
  base: {
    id: 'base',
    label: 'KIT PSICOLOGÍA EN GERONTES',
    oldPrice: '$49.990',
    price: '$19.990',
    url: 'http://checkout.sectordigital.online/cart/44174195425323:1'
  },
  combo: {
    id: 'combo',
    label: 'KIT + DEPRESIÓN EN GERONTES',
    oldPrice: '$69.990',
    price: '$29.990',
    url: 'http://checkout.sectordigital.online/cart/44197457952811:1'
  }
};
export function Pricing() {
  const [selected, setSelected] = useState<OfferId>('combo');
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      const diff = tomorrow.getTime() - now.getTime();
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(diff % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    };
    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(interval);
  }, []);
  const handleCheckout = () => {
    window.location.href = OFFERS[selected].url;
  };
  const includes = [{
    text: 'Todo el KIT Psicología en Gerontes',
    accent: false
  }, {
    text: 'Libro: Depresión en Gerontes',
    accent: true
  }, {
    text: 'Intervención en depresión del adulto mayor',
    accent: false
  }, {
    text: 'BONUS: Psicoeducación para Familias',
    accent: true
  }, {
    text: 'BONUS: Banco de Actividades Terapéuticas',
    accent: true
  }];
  const current = OFFERS[selected];
  return <section id="comprar" className="w-full py-4 md:py-10 bg-[#faf9f7]" data-id="element-73">
      <div className="max-w-md mx-auto px-3" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-75">
          {/* Timer */}
          <div id="oferta-reloj" className="bg-gradient-to-br from-red-600 to-red-700 rounded-xl p-2.5 shadow-lg scroll-mt-2" data-id="element-76">
            <div className="flex items-center justify-center gap-1.5 text-white mb-1.5" data-id="element-77">
              <Clock className="w-3.5 h-3.5 animate-pulse" data-id="element-78" />
              <span className="font-bold uppercase tracking-wide text-[11px]" data-id="element-79">
                Oferta termina en:
              </span>
            </div>
            <div className="flex items-center justify-center gap-1.5" data-id="element-80">
              {[{
              value: timeLeft.hours,
              label: 'Horas'
            }, {
              value: timeLeft.minutes,
              label: 'Min'
            }, {
              value: timeLeft.seconds,
              label: 'Seg'
            }].map((unit, idx) => <Fragment key={unit.label} data-id="element-81">
                  <div className="flex flex-col items-center" data-id="element-82">
                    <span className="bg-white text-red-600 rounded-md px-2 py-1 text-lg font-bold tabular-nums shadow-md min-w-[2.25rem] text-center" data-id="element-83">
                      {String(unit.value).padStart(2, '0')}
                    </span>
                    <span className="text-white/90 text-[8px] font-semibold mt-0.5 uppercase tracking-wide" data-id="element-84">
                      {unit.label}
                    </span>
                  </div>
                  {idx < 2 && <span className="text-white text-lg font-bold pb-3" data-id="element-85">:</span>}
                </Fragment>)}
            </div>
          </div>

          {/* Note banner */}
          <div className="bg-[#fdf6e9] border border-[#f0d9a8] rounded-lg p-2 mt-2 flex items-start gap-2" data-id="element-86">
            <div className="w-6 h-6 rounded-full bg-[#d97706] flex items-center justify-center flex-shrink-0" data-id="element-87">
              <Sparkles className="w-3.5 h-3.5 text-white" data-id="element-88" />
            </div>
            <p className="text-[11px] leading-snug text-gray-700" data-id="element-89">
              Sumá el libro{' '}
              <span className="font-bold" data-id="element-90">"Depresión en Gerontes"</span> y
              trabajá la detección, evaluación e intervención de la depresión en
              adultos mayores.
            </p>
          </div>

          {/* Card */}
          <div className="bg-white rounded-xl shadow-2xl border border-gray-200 mt-2 overflow-hidden" data-id="element-91">
            {/* Mockup */}
            <div className="flex justify-center pt-2 pb-1 px-4" data-id="element-92">
              <img src="https://cdn.magicpatterns.com/uploads/tZEftTVcGnx5Fst7AkPLEm/Diseno_sin_titulo_(38).png" alt="KIT Psicología en Gerontes + libro Depresión en Gerontes" className="w-full max-w-[170px] h-auto" data-id="element-93" />
            </div>

            {/* Offer options */}
            <div className="px-3 pb-2 space-y-2" data-id="element-94">
              {(['base', 'combo'] as OfferId[]).map(id => {
              const offer = OFFERS[id];
              const isSelected = selected === id;
              const isCombo = id === 'combo';
              return <button key={id} type="button" onClick={() => setSelected(id)} aria-pressed={isSelected} className={`w-full text-left rounded-lg border-2 p-2.5 transition-all duration-200 relative ${isSelected ? 'border-[#d97706] bg-[#fdf6e9]' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-95">
                    {isCombo && <span className="absolute -top-2 right-3 bg-[#d97706] text-white text-[9px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full flex items-center gap-1" data-id="element-96">
                        <Crown className="w-2.5 h-2.5" data-id="element-97" />
                        Más elegida
                      </span>}
                    <div className="flex items-center justify-between gap-2" data-id="element-98">
                      <div className="flex items-center gap-2" data-id="element-99">
                        <span className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${isSelected ? 'border-[#d97706] bg-[#d97706]' : 'border-gray-300'}`} data-id="element-100">
                          {isSelected && <Check className="w-2.5 h-2.5 text-white" strokeWidth={3} data-id="element-101" />}
                        </span>
                        <span className="font-bold text-[13px] text-[#14505c] leading-tight" data-id="element-102">
                          {offer.label}
                        </span>
                      </div>
                      <div className="text-right flex-shrink-0" data-id="element-103">
                        <span className="block text-[10px] text-gray-400 line-through" data-id="element-104">
                          {offer.oldPrice}
                        </span>
                        <span className="block text-base font-bold text-[#14505c]" data-id="element-105">
                          {offer.price}
                        </span>
                      </div>
                    </div>
                  </button>;
            })}
            </div>

            {/* Includes */}
            <div className="mx-3 mb-2 bg-[#faf9f7] rounded-lg p-2.5" data-id="element-106">
              <p className="font-bold text-[10px] uppercase tracking-wide text-gray-700 mb-1.5" data-id="element-107">
                Incluye:
              </p>
              <ul className="space-y-1" data-id="element-108">
                {includes.map((item, index) => <li key={index} className="flex items-start gap-1.5" data-id="element-109">
                    <Check className={`w-3.5 h-3.5 flex-shrink-0 mt-0.5 ${item.accent ? 'text-[#d97706]' : 'text-green-600'}`} strokeWidth={3} data-id="element-110" />
                    <span className={`text-[12px] leading-tight ${item.accent ? 'text-[#d97706] font-semibold' : 'text-gray-700'}`} data-id="element-111">
                      {item.text}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* Purchase box */}
            <div className="bg-[#14352b] m-2 rounded-xl p-3 text-center" data-id="element-112">
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-113">
                <span className="text-base text-white/50 line-through" data-id="element-114">
                  {current.oldPrice}
                </span>
                <span className="text-3xl font-bold text-white" data-id="element-115">
                  {current.price}
                </span>
                <span className="text-xs text-white/70 self-end mb-1" data-id="element-116">ARS</span>
              </div>
              <button onClick={handleCheckout} className="bg-[#d4a017] hover:bg-[#c08f15] text-white font-bold text-base px-5 py-3 rounded-lg transition-colors duration-200 shadow-lg w-full uppercase tracking-wide" data-id="element-117">
                Sí, quiero el kit ahora
              </button>
              <p className="text-center text-[11px] text-white/70 mt-2" data-id="element-118">
                Pago único · Acceso inmediato · Garantía 7 días
              </p>
              <div className="flex items-center justify-center gap-1 mt-1 text-white/80" data-id="element-119">
                <Star className="w-3 h-3 fill-[#d4a017] text-[#d4a017]" data-id="element-120" />
                <span className="text-[11px] font-semibold" data-id="element-121">
                  +500 profesionales
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}